<template>
  <v-form ref="form" v-on:submit.prevent v-model="valid">
    <v-row no-gutters class="mb-8">
      <v-col cols="12">
        <div class="font font--p-sm link-contract d-flex">
          <div>
            <v-img src="@/assets/img/info.svg" style="width: 20px; height: 20px; margin-right: 13px"></v-img>
          </div>
          <div>Одновременно можно выбрать один или все {{ productList.length }} продукта</div>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="mb-5">
      <v-col v-for="product in productList" :key="product.value" cols="6" sm="4" md="4" lg="3">
        <v-checkbox
          :rules="[rules.minOne]"
          color="#88BD1F"
          dense
          required
          :label="product.label"
          v-model="products"
          :value="product.value"
          :disabled="product.disabledState"
          :hint="product.hint"
          persistent-hint
        />
      </v-col>
    </v-row>

    <v-row v-if="products.includes('ACCOPEN')" no-gutters>
      <v-col cols="12" class="caption">Услуги РКО:</v-col>
      <v-col v-for="service in RKOServices" cols="6" md="4" class="mb-6 mt-2 d-flex justify-start align-center">
        <v-checkbox
          :label="service.title"
          :value="service.name"
          v-model="appliedRKOServices"
          color="#88BD1F"
          hide-details
          class="ma-1"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-img
              class="flex-grow-0 flex-shrink-0"
              src="@/assets/img/info.svg"
              v-bind="attrs"
              v-on="on"
              :style="{ width: '20px', height: '20px' }"
            ></v-img>
          </template>
          <span v-if="service.description">{{ service.description }}</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" class="font--color_light font--label">
        <label v-if="!isNewCompany">Наименование клиента</label>
        <v-text-field
          v-if="isNewCompany"
          v-model="company_name"
          :rules="[rules.required('Введите название')]"
          outlined
          label="Название"
          dense
          style="margin-bottom: 10px"
        />
        <CompanySearch
          placeholder="Наименование, ИНН или ОГРН/ОГРНИП клиента"
          v-else
          v-on:create-company="handleCreateCompany"
          class="mb-9"
          v-model="company"
          :rules="[rules.required('')]"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row no-gutters style="margin-bottom: 10px">
      <v-col cols="12" sm="6" class="pr-sm-2 font--color_light font--label">
        <v-text-field
          dense
          :disabled="!isNewCompany"
          :rules="[rules.required('Введите ИНН'), rules.inn]"
          outlined
          v-model="inn"
          name="inn"
          label="ИНН"
          v-mask="['##########', '############']"
        />
      </v-col>
      <v-col cols="12" sm="6" class="font--color_light font--label">
        <v-text-field
          dense
          :disabled="!isNewCompany"
          :rules="[rules.required('Введите ОГРН'), rules.ogrn]"
          outlined
          v-model="ogrn"
          name="ogrn"
          :label="ogrnLabel"
          v-mask="['#############', '###############']"
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" class="font--color_light font--label mb-9">
        <MaskedTextField
          :pattern="/[А-Яа-яёЁ-]/"
          :rules="[rules.required('Введите фамилию контактного лица')]"
          v-model="person_surname"
          label="Фамилия контактного лица"
        />
      </v-col>
      <v-col cols="12" class="font--color_light font--label mb-9">
        <MaskedTextField
          :pattern="/[А-Яа-яёЁ]/"
          :rules="[rules.required('Введите имя контактного лица')]"
          v-model="person_firstname"
          label="Имя контактного лица"
        />
      </v-col>
      <v-col cols="12" class="font--color_light font--label mb-9">
        <MaskedTextField
          :pattern="/[\sА-Яа-яёЁ]/"
          :rules="[rules.required('Введите отчество контактного лица')]"
          v-model="person_middlename"
          label="Отчество контактного лица"
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="6" class="pr-sm-2 font--color_light font--label">
        <v-text-field
          :rules="[rules.required('Введите Номер телефона'), rules.phone]"
          outlined
          required
          style="text-align: center"
          label="Телефон контактного лица"
          v-model="phone"
          name="phone"
          type="text"
          dense
        />
      </v-col>
      <v-col cols="12" sm="6" class="font--color_light font--label">
        <v-text-field :rules="[rules.email]" v-model="email" outlined label="Электронная почта" dense />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="font--color_light font--label">
        <v-textarea
          counter="2048"
          :rules="[rules.comment]"
          label="Комментарий"
          rows="3"
          outlined
          v-model="comment"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-btn color="primary" @click="sendBid" :disabled="!valid">Создать заявку</v-btn>
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import { validateInn, validateOgrn } from "@/utils/helpers";
import { email as ruleEmail } from "@/utils/rules";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import CompanySearch from "@/components/common/CompanySearch";
import MaskedTextField from "@/components/common/MaskedTextField";
import formatPhone from "../../utils/formatPhone";

export default {
  directives: { mask },
  data() {
    return {
      tooltipText: "Здесь будет текст про то что сюда можно вписать",
      isNewCompany: false,
      valid: false,
      productList: [
        {
          value: "ACCOPEN",
          label: "РКО",
        },
        {
          value: "MERCHANT.IA",
          label: "Интернет эквайринг",
        },
        {
          value: "MODULKASSA",
          label: "Касса",
        },
        {
          value: "MERCHANT.TA",
          label: "Торговый эквайринг",
        },
        {
          value: "CLOUDPAY",
          label: "Облачные чеки",
          disabledState: false, // FIXME: сервер может отправлять условия, нужно забирать (место пока не определено)
          hint: "Доступно вместе с РКО",
        },
      ],
      RKOServices: [
        {
          title: "Маркетплейс",
          description:
            "Персональный менеджер, вывод на счета физ.лиц - 0%, снятие наличных - 1%, статистика продаж конкурентов.",
          name: "MARKETPLACE",
        },
        {
          title: "МодульБлэк",
          description: "Премиальное сопровождение, спец. условия, защита по 115-ФЗ, возможность кредитоваться.",
          name: "MODULBLACK",
        },
        {
          title: "Зелёный лимит",
          description: "Безлимитный вывод на счета физлиц за 0,75% зачислений от надежных контрагентов",
          name: "GREENLIMIT",
        },
        {
          title: "Валютный счёт",
          description: "Валютные операции с нерезидентами без комиссии",
          name: "FOREIGNCURRENCY",
        },
        {
          title: "КафеСтор",
          description: "Наш новый проект — первая в России платформа для кофеен",
          name: "CAFESTORE",
        },
      ],
      rules: {
        minOne: (v) => v.length > 0 || "Выберите продукт",
        required: (msg) => (v) => !!v || msg,
        inn: (v) => (validateInn(v) && this.isInnMatchOgrn) || "Введите корректный ИНН",
        ogrn: (v) => !v || (validateOgrn(v) && this.isOgrnMatchInn) || "Введите корректный " + this.ogrnLabel,
        email: (v) => !v || ruleEmail(v),
        phone: (v) => v.replace(/\D/g, "").length === 11 || "Введите номер телефона",
        comment: (v) => !v || v.length <= 2048 || "Максимум 2048 символов",
      },
    };
  },
  computed: {
    ...mapState({
      stg: (state) => state.bid.stg,
      stateInn: (state) => state.bid.inn,
      statePhone: (state) => state.bid.person_phone,
      stateEmail: (state) => state.bid.person_email,
      stateOgrn: (state) => state.bid.ogrn,
      stateFirstname: (state) => state.bid.person_firstname,
      stateSurname: (state) => state.bid.person_surname,
      stateMiddlename: (state) => state.bid.person_middlename,
      stateComment: (state) => state.bid.comment,
      stateCompanyName: (state) => state.bid.company_name,
      showNewBid: (state) => state.common.showNewBid,
      stateAppliedRKOServices: (state) => state.bid.appliedRKOServices,
    }),
    products: {
      get() {
        return this.stg;
      },
      set(value) {
        this.set({ type: "stg", value });
      },
    },
    company: {
      get() {
        return this.$store.state.bid.company;
      },
      set(value) {
        this.$store.commit("bid/set", { type: "company", value });
      },
    },
    company_name: {
      get() {
        return this.stateCompanyName;
      },
      set(value) {
        this.set({ type: "company_name", value });
      },
    },

    inn: {
      get() {
        return this.stateInn;
      },
      set(value) {
        this.set({ type: "inn", value });
      },
    },
    phone: {
      get() {
        return this.statePhone || "";
      },
      set(newVal) {
        const _value = formatPhone(newVal);
        this.set({ type: "person_phone", value: _value });
      },
    },
    email: {
      get() {
        return this.stateEmail;
      },
      set(value) {
        this.set({ type: "person_email", value });
      },
    },
    ogrn: {
      get() {
        return this.stateOgrn;
      },
      set(value) {
        this.set({ type: "ogrn", value });
      },
    },
    person_firstname: {
      get() {
        return this.stateFirstname;
      },
      set(value) {
        this.set({ type: "person_firstname", value });
      },
    },
    person_surname: {
      get() {
        return this.stateSurname;
      },
      set(value) {
        this.set({ type: "person_surname", value });
      },
    },
    person_middlename: {
      get() {
        return this.stateMiddlename;
      },
      set(value) {
        this.set({ type: "person_middlename", value });
      },
    },
    comment: {
      get() {
        return this.stateComment;
      },
      set(value) {
        this.set({ type: "comment", value });
      },
    },
    appliedRKOServices: {
      get() {
        return this.stateAppliedRKOServices;
      },
      set(value) {
        this.set({ type: "appliedRKOServices", value });
      },
    },
    // Для валидации соответствия ИНН - ОГРН
    isInnIp() {
      return !!this.inn && this.inn.length === 12;
    },
    isInnUl() {
      return !!this.inn && this.inn.length === 10;
    },
    isOgrn() {
      return !!this.ogrn && this.ogrn.length === 13;
    },
    isOgrnip() {
      return !!this.ogrn && this.ogrn.length === 15;
    },
    isInnMatchOgrn() {
      return this.isOgrn ? this.isInnUl : this.isOgrnip ? this.isInnIp : true;
    },
    isOgrnMatchInn() {
      return this.isInnUl ? this.isOgrn : this.isInnIp ? this.isOgrnip : true;
    },
    ogrnLabel() {
      return this.isInnIp ? "ОГРНИП" : this.isInnUl ? "ОГРН" : "ОГРН/ОГРНИП";
    },
  },
  watch: {
    company(company) {
      if (company) {
        this.inn = company.inn;
        this.ogrn = company.ogrn;
      } else {
        this.inn = "";
        this.ogrn = "";
      }
    },
    showNewBid(show) {
      if (!show) {
        this.resetValidation();
      }
    },
    // для повторной валидации в случае изменения типа инн / огрн
    isInnUl() {
      if (this.ogrn) {
        this.validateInnAndOgrn();
      }
    },
    isInnIp() {
      if (this.ogrn) {
        this.validateInnAndOgrn();
      }
    },
    isOgrn() {
      if (this.inn) {
        this.validateInnAndOgrn();
      }
    },
    isOgrnip() {
      if (this.inn) {
        this.validateInnAndOgrn();
      }
    },
    stg(newValue, oldValue) {
      const cloudPayIndex = this.productList.findIndex((element) => element.value === "CLOUDPAY");
      if (cloudPayIndex !== -1) {
        this.$set(this.productList, cloudPayIndex, {
          ...this.productList[cloudPayIndex],
          disabledState: newValue.includes("ACCOPEN") === false,
        });
      }
    },
  },
  mounted() {},
  methods: {
    ...mapMutations("bid", ["set"]),
    ...mapActions("bid", ["allProduct"]),
    handleCreateCompany() {
      this.isNewCompany = true;
      this.company = null;
    },
    resetValidation() {
      this.isNewCompany = false;
      this.$refs.form.resetValidation();
    },
    sendBid() {
      this.allProduct();
      this.resetValidation();
    },
    validateInnAndOgrn() {
      this.$refs.form.inputs.forEach((i) => {
        if (i.$attrs.name === "ogrn" || i.$attrs.name === "inn") {
          i.validate();
        }
      });
    },
  },
  components: {
    MaskedTextField,
    CompanySearch,
  },
};
</script>

<style scoped>
.link-contract {
  background: #f5f5f6;
  border-radius: 3px;
  padding: 14px 14px;
}

.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>
